import { msg } from '@lingui/core/macro';

export const SHARED_CONSENT_CENTER_TAB_INFO_DESCRIPTION = msg`These consent settings are read-only and reflect your current agreements.`;
export const SHARED_CONSENT_CENTER_TAB_TITLE = msg`Consent Center`;
export const SHARED_CONSENT_CENTER_TAB_DESCRIPTION = msg`Manage your data and consent preferences`;
